<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="success" class="button-shadow" to="/payroll/list">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
    <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="8" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width:40%"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.payrolldate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Period Start</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date(initvalue.payrollstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Period End</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date(initvalue.payrollenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                    <tr>
                      <td colspan="3"><div align="center"><h4 class="ma-0"><b>{{ initvalue.payrollname }}</b></h4></div></td>
                    </tr>
                  </table>
                </v-row>
                <v-row justify="space-between">
                  <table v-for="(statement, index) in data_statements"  v-bind:key="statement._id" style="table-layout: fixed;width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td><span style="font-size: 11pt; font-weight: bold">Name: {{ statement.paystatementname  }}</span></td>
                      <td style="text-align: right"><span style="font-size: 11pt; font-weight: bold; text-alignment: right;">Statement Num: {{ statement.paystatementnum }}</span></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="vertical-align:top">
                        <table width="100%">
                          <tr>
                            <td width=49% style="vertical-align:top">
                              <table style="border-collapse: collapse; border-spacing: 0">
                                <tr>
                                  <td width="50%" colspan="2" style="text-align: left; border-bottom: 2px; border-bottom-style: solid;"><span style="font-size: 11pt;"><strong>Additions</strong></span></td>
                                  <td v-if="statement.isDualCurrency==true" width="20%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">{{ statement.transactions[0].transcurrency2 }}</td>
                                  <td width="15%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">CUR</td>
                                  <td width="15%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">YTD</td>
                                </tr>
                                <tr v-for="(trans, index) in statement.transactions.filter(trans=>trans.transsubtype=='Addition')"  v-bind:key="trans._id">
                                  <td width="2%" style="vertical-align:top">{{ index + 1 }}</td>
                                  <td width="48%" style="font-size: 9pt;">{{ trans.transdesc }}</td>
                                  <td v-if="statement.isDualCurrency==true" width="20%" style="text-align: right;"><span style="font-size: 9pt;">{{ (trans.transcredit2).toFixed(0) }}</span></td>
                                  <td width="15%" style="text-align: right; padding: 0; margin-right:10px;">{{ trans.transcredit.toFixed(2) }}</td>
                                  <td width="15%" style="text-align: right; padding: 0; margin-right:10px;">{{ ((trans.transcredit) + (initvalue.balance_ytd!==null && statement.balance_ytd.find(x=>x._id==trans.accountid)!==undefined ? statement.balance_ytd.find(x=>x._id==trans.accountid).transcredit : 0)).toFixed(2) }}</td>
                                </tr>
                                <tr>
                                  <td width="70%" :colspan="statement.isDualCurrency==true ? 3 : 2" style="text-align: right; border-top: 1px solid;"><span style="white-space:nowrap; margin-right:8px; "><strong>Gross Pay:</strong></span></td>
                                  <td width="15%" style="text-align: right; border-top: 1px solid;"><span style="font-size: 11pt;">{{ (sumAdditions(statement)).toFixed(2) }}</span></td>
                                  <td width="15%" style="text-align: right; border-top: 1px solid; "><span style="font-size: 11pt;">{{ sumAdditionsYtd(statement).toFixed(2) }}</span></td>
                                </tr>
                                <tr>
                                  <td width="50%" colspan="2" style="text-align: left; border-bottom: 2px; border-bottom-style: solid;"><span style="font-size: 11pt; "><strong>Deductions</strong></span></td>
                                  <td v-if="statement.isDualCurrency==true" width="20%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">{{ statement.transactions[0].transcurrency2 }}</td>
                                  <td width="15%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">CUR</td>
                                  <td width="15%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">YTD</td>
                                </tr>
                                <tr v-for="(trans, index) in statement.transactions.filter(trans=>trans.transsubtype=='Deduction')"  v-bind:key="trans._id">
                                  <td width="2%" style="vertical-align:top">{{ index + 1 }}</td>
                                  <td width="48%" style="font-size: 9pt;">{{ trans.transdesc }}</td>
                                  <td v-if="statement.isDualCurrency==true" width="20%" style="text-align: right;"><span style="font-size: 9pt;">{{ (trans.transdebit2).toFixed(0) }}</span></td>
                                  <td width="15%" style="text-align: right">{{ trans.transdebit.toFixed(2) }}</td>
                                  <td width="15%" style="text-align: right">{{ ((trans.transdebit) + (statement.balance_ytd!==null && statement.balance_ytd.find(x=>x._id==trans.accountid)!==undefined ? statement.balance_ytd.find(x=>x._id==trans.accountid).transdebit : 0)).toFixed(2) }}</td>
                                </tr>
                                <tr>
                                  <td width="70%" :colspan="statement.isDualCurrency==true ? 3 : 2" style="text-align: right; border-top: 1px solid;"><span style="white-space:nowrap; margin-right:8px; "><strong>Net Pay:</strong></span></td>
                                  <td width="15%" style="text-align: right; border-top: 1px solid;"><span style="font-size: 11pt;">{{ (sumAdditions(statement) - sumDeductions(statement)).toFixed(2) }}</span></td>
                                  <td width="15%" style="text-align: right; border-top: 1px solid;"><span style="font-size: 11pt;">{{ (sumAdditionsYtd(statement) - sumDeductionsYtd(statement)).toFixed(2) }}</span></td>
                                </tr>
                                <tr>
                                  <td width="50%" colspan="2" style="text-align: left; border-bottom: 2px; border-bottom-style: solid;"><span style="font-size: 11pt;"><strong>Employer Contributions</strong></span></td>
                                  <td v-if="statement.isDualCurrency==true" width="20%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">{{ statement.transactions[0].transcurrency2 }}</td>
                                  <td width="15%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">CUR</td>
                                  <td width="15%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">YTD</td>
                                </tr>
                                <tr v-for="(trans, index) in statement.transactions.filter(trans=>trans.transsubtype=='Contribution')"  v-bind:key="trans._id">
                                  <td width="2%" style="vertical-align:top">{{ index + 1 }}</td>
                                  <td width="48%" style="font-size: 9pt;">{{ trans.transdesc }}</td>
                                  <td v-if="statement.isDualCurrency==true" width="20%" style="text-align: right;"><span style="font-size: 9pt;">{{ (trans.transcredit2).toFixed(0) }}</span></td>
                                  <td width="15%" style="text-align: right">{{ trans.transcredit.toFixed(2) }}</td>
                                  <td width="15%" style="text-align: right">{{ ((trans.transcredit) + (statement.balance_ytd!==null && statement.balance_ytd.find(x=>x._id==trans.accountid)!==undefined ? statement.balance_ytd.find(x=>x._id==trans.accountid).transcredit : 0)).toFixed(2) }}</td>
                                </tr>
                                <tr><td colspan="5" style="border-top: 1px solid">&nbsp;</td></tr>
                              </table>
                            </td>
                            <td width="1%" style="vertical-align:top"></td>
                            <td width="49%" style="vertical-align:top">
                              <table style="width: 100%" cellpadding="0" cellspacing="0">
                                  <thead>
                                  <tr>
                                    <th width="52%" colspan="2" style="text-align: left; border-bottom: 2px; border-bottom-style: solid;"><span style="font-size: 12pt; margin-left:10px; "><strong>Paid Leave</strong></span></th>
                                    <th width="13%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Inc</th>
                                    <th width="13%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Dec</th>
                                    <th width="13%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Bal</th>
                                  </tr>
                                  </thead>
                                  <tbody v-if="statement.balance_all.length>0 && statement.balance_all.find(trans=>trans.transsubtype=='Benefit')!=null">
                                      <tr v-for="(trans, index) in statement.balance_all.filter(trans=>trans.transsubtype=='Benefit')"  v-bind:key="trans._id">
                                        <td width="2%" style="vertical-align:top">{{ index + 1 }}</td>
                                        <td width="50%" style="font-size: 9pt;">{{ trans.transdesc + ' ' + getTransactionString(statement, trans._id) }}</td>
                                        <td width="13%" style="text-align: right">{{ getCreditAmountByAccount(statement, trans._id).toFixed(2) }}</td>
                                        <td width="13%" style="text-align: right">{{ getDebitAmountByAccount(statement, trans._id).toFixed(2) }}</td>
                                        <td width="13%" style="text-align: right">{{ (calculateBalanceByAccount(statement, trans._id) + (trans.transcredit - trans.transdebit)).toFixed(2) }}</td>
                                      </tr>
                                      <tr><td colspan="5" style="border-top: 1px solid">&nbsp;</td></tr>
                                  </tbody>
                                  <tbody v-else>
                                      <tr v-for="(trans, index) in getBenefitSum(statement).filter(trans=>trans.transsubtype=='Benefit')"  v-bind:key="trans._id">
                                        <td width="2%" style="vertical-align:top">{{ index + 1 }}</td>
                                        <td width="50%" style="font-size: 9pt;">{{ trans.transdesc + ' '  + getTransactionString(statement, trans.accountid) }}</td>
                                        <td width="13%" style="text-align: right">{{ trans.transcredit.toFixed(2) }}</td>
                                        <td width="13%" style="text-align: right">{{ trans.transdebit.toFixed(2)  }}</td>
                                        <td width="13%" style="text-align: right">{{ (calculateBalanceAll(statement, trans.accountid) + (trans.transcredit - trans.transdebit)).toFixed(2) }}</td>
                                      </tr>
                                      <tr><td colspan="5" style="border-top: 1px solid">&nbsp;</td></tr>
                                  </tbody>
                                  <tr>
                                    <td colspan="5"><span style="font-size: 9pt; font-weight: bold">Payment Method:</span> {{ statement.paymethod}}</td>
                                  </tr>
                                  <tr v-if="statement.isDualCurrency==true">
                                    <td colspan="5"><span style="font-size: 9pt; font-weight: bold">Currency:</span> {{ statement.transactions[0].transcurrency}} / {{ statement.transactions[0].transcurrency2}}</td>
                                  </tr>
                                  <tr v-if="statement.isDualCurrency==true">
                                    <td colspan="5"><span style="font-size: 9pt; font-weight: bold">Currency Rate:</span> {{ statement.currencyRate}} | {{ statement.currencyRate2}}</td>
                                  </tr>
                                  <tr>
                                    <td colspan="5"><span style="font-size: 9pt; font-weight: bold">Note:</span> {{ statement.paystatementnote}}</td>
                                  </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr v-if="index<data_statements.length-1"><td colspan="2" style="border-top: 2px solid">&nbsp;</td></tr>
                  </table>
                </v-row>
                <v-row>
                <table style="width: 100%; border-collapse: collapse; border-spacing: 0" cellpadding="0" cellspacing="0">
                <tr>
                  <td style="width: 5%; border-top: 2px solid;">&nbsp;</td>
                  <td style="width: 30%; border-top: 2px solid;">&nbsp;</td>
                  <td style="width: 18%; padding: 10px; font-size: 11pt; height: 40px; border-left: 2px solid; border-top: 2px solid; border-bottom: 2px solid"><strong>Gross Payroll</strong> <span style="font-size: 8pt;">{{ primaryCurrency }}</span></td>
                  <td style="width: 12%; padding: 10px; text-align: right;  height: 40px; border-top: 2px solid; border-bottom: 2px solid"><strong>{{ totalGross().toFixed(2) }}</strong></td>
                  <td style="width: 18%; padding: 10px; font-size: 11pt; height: 40px; border-left: 2px solid; border-top: 2px solid; border-bottom: 2px solid"><strong>Net Payroll</strong> <span style="font-size: 8pt;">{{ primaryCurrency }}</span></td>
                  <td style="width: 12%; padding: 10px; text-align: right; height: 40px; border-right: 2px solid; border-top: 2px solid; border-bottom: 2px solid"><strong>{{ (totalGross() - totalDeduction()).toFixed(2) }}</strong></td>
                </tr>
                <tr v-if="isDualCurrency==true">
                  <td style="width: 5%;">&nbsp;</td>
                  <td style="width: 30%;">&nbsp;</td>
                  <td style="width: 18%; padding: 10px; font-size: 11pt; height: 40px; border-left: 2px solid; border-top: 2px solid; border-bottom: 2px solid"><strong>Gross Payroll</strong> <span style="font-size: 8pt;">{{ secondaryCurrency }}</span></td>
                  <td style="width: 12%; padding: 10px; text-align: right;  height: 40px; border-top: 2px solid; border-bottom: 2px solid"><strong>{{ (totalGross() * currencyRate).toFixed(0) }}</strong></td>
                  <td style="width: 18%; padding: 10px; font-size: 11pt; height: 40px; border-left: 2px solid; border-top: 2px solid; border-bottom: 2px solid"><strong>Net Payroll</strong> <span style="font-size: 8pt;">{{ secondaryCurrency }}</span></td>
                  <td style="width: 12%; padding: 10px; text-align: right; height: 40px; border-right: 2px solid; border-top: 2px solid; border-bottom: 2px solid"><strong>{{ ((totalGross() * currencyRate) - (totalDeduction() * currencyRate)).toFixed(0) }}</strong></td>
                </tr>
                  <tr>
                  <td colspan="2">
                    <table style="width: 200px" cellpadding="0" cellspacing="0">
                  <tr v-if="initvalue.approval && initvalue.payrollstatus=='Complete' && initvalue.approval.approverid!=null"><td colspan="2" style="text-align: center; padding-bottom: 5px;"><img :src="initvalue.approval.approvalsignature" :height="60" /></td></tr>
                  <tr v-else><td colspan="2" style="text-align: center; padding-bottom: 5px;"><div style="height: 60px;">&nbsp;</div></td></tr>
                  <tr><td colspan="2" style="text-align: right; border-bottom: 2px; border-bottom-style: solid"></td></tr>
                  <tr v-if="initvalue.approval && initvalue.payrollstatus=='Complete' && initvalue.approval.approverid!=null"><td style="text-align: left;"><span style="font-size: 9pt;">{{ initvalue.approval.approvalname }}</span></td><td style="text-align: right;"><span style="font-size: 9pt;">Ref #{{ initvalue.approval.approvalidnum }}</span></td></tr>
                </table>
                  </td>
                  <td colspan="4" style="width: 70%; height: 70px; ">&nbsp;</td>
                </tr>
                </table>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
    </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo } from '../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            initvalue: {},
            paystatementaddress: null,
            benefit_sum: [],
            saving_sum: [],
            data_statements: [],
            logo: null,
            format: 0,
            isDualCurrency: false,
            currencyRate: 1,
            primaryCurrency: '',
            secondaryCurrency: '',
            style0: 'height: 60px; max-width: 200px;',
            style1: 'height: 100px; max-width: 100px;',
          };
        },
        computed: {
          ...mapState('Employee', ['employees']),
          ...mapState('User', ['users']),
        },
        methods: {
          ...mapActions('User', ['getUsersRequest']),
          ...mapActions('Payroll', ['getPayrollRequest']),
          ...mapActions('Employee', ['getEmployeesRequest']),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            setTimeout(function() {
              mywindow.print();
            }, 1000);
            return;
          },
          totalGross(){
            let total = 0;
            for(var index in this.data_statements){
              let statement = this.data_statements[index];
              var list =  statement.transactions.map( trans => trans.transsubtype=='Addition' ? trans.transcredit : 0 );
              let sum = list.reduce((a,b)=>a+b, 0);
              total = total + sum;
            }
            return total;
          },
          totalDeduction(){
            let total = 0;
            for(var index in this.data_statements){
              let statement = this.data_statements[index];
              var list =  statement.transactions.map( trans => trans.transsubtype=='Deduction' ? trans.transdebit : 0 );
              let sum = list.reduce((a,b)=>a+b, 0);
              total = total + sum;
            }
            return total;
          },
          sumAdditions(statement){
            console.log("1", statement);
            //if(statement.transactions.length==0) return 0;
            
            var list =  statement.transactions.map( trans => trans.transsubtype=='Addition' ? trans.transcredit : 0 );
            return list.reduce((a,b)=>a+b, 0);
          },
          sumAdditionsYtd(statement){
            if(statement.balance_ytd==null || statement.balance_ytd.length==0) return this.sumAdditions(statement);
            var list =  statement.balance_ytd.map( trans => trans.transsubtype=='Addition' ? trans.transcredit : 0 );
            return this.sumAdditions(statement) + list.reduce((a,b)=>a+b, 0);
          },
          sumDeductions(statement){
            var list =  statement.transactions.map( trans => trans.transsubtype=='Deduction' ? trans.transdebit : 0  );
            return list.reduce((a,b)=>a+b, 0);
          },
          sumDeductionsYtd(statement){
            if(statement.balance_ytd==null || statement.balance_ytd.length==0) return this.sumDeductions(statement);
            var list =  statement.balance_ytd.map( trans => trans.transsubtype=='Deduction' ? trans.transdebit : 0 );
            return this.sumDeductions(statement) + list.reduce((a,b)=>a+b, 0);
          },
          sumContribution(){
            var list =  this.initvalue.transactions.map( trans => trans.transsubtype=='Contribution' ? trans.transcredit : 0  );
            return list.reduce((a,b)=>a+b, 0);
          },
          sumContributionYtd(){
            if(this.initvalue.balance_ytd==null || this.initvalue.balance_ytd.length==0) return this.sumContribution();
            var list =  this.initvalue.balance_ytd.map( trans => trans.transsubtype=='Contribution' ? trans.transcredit : 0 );
            return this.sumContribution() + list.reduce((a,b)=>a+b, 0);
          },
          calculateBalanceAll(statement, accountid){
            let credit = statement.balance_all!==null && statement.balance_all.find(x=>x._id==accountid)!==undefined ? statement.balance_all.find(x=>x._id==accountid).transcredit : 0;
            let debit = statement.balance_all!==null && statement.balance_all.find(x=>x._id==accountid)!==undefined ? statement.balance_all.find(x=>x._id==accountid).transdebit : 0;
            return credit-debit;
          },
          calculateBalanceSaving(){
            let credit = this.initvalue.balance_all!==null && this.initvalue.balance_all.find(x=>x.transsubtype=='Saving')!==undefined ? this.initvalue.balance_all.find(x=>x.transsubtype=='Saving').transcredit : 0;
            let debit = this.initvalue.balance_all!==null && this.initvalue.balance_all.find(x=>x.transsubtype=='Saving')!==undefined ? this.initvalue.balance_all.find(x=>x.transsubtype=='Saving').transdebit : 0;
            return credit-debit;
          },
          calculateBalanceByAccount(statement, accountid){
            console.log(accountid);
            let sum = statement.transactions.filter(trans=>trans.accountid==accountid);
            var credit_list =  sum.map( trans => trans.transcredit!==null ? trans.transcredit : 0 );
            var debit_list =  sum.map( trans => trans.transdebit!==null ? trans.transdebit : 0 );
            let credit = credit_list.length==0 ? 0 : credit_list.reduce((a,b)=>a+b, 0);
            let debit = debit_list.length==0 ? 0 : debit_list.reduce((a,b)=>a+b, 0);
            return credit-debit;
          },
          getCreditAmountByAccount(statement, accountid){
            let sum = statement.transactions.filter(trans=>trans.accountid==accountid);
            var credit_list =  sum.map( trans => trans.transcredit!==null ? trans.transcredit : 0 );
            let credit = credit_list.length==0 ? 0 : credit_list.reduce((a,b)=>a+b, 0);
            return credit;
          },
          getDebitAmountByAccount(statement, accountid){
            let sum = statement.transactions.filter(trans=>trans.accountid==accountid);
            var debit_list =  sum.map( trans => trans.transdebit!==null ? trans.transdebit : 0 );
            let debit = debit_list.length==0 ? 0 : debit_list.reduce((a,b)=>a+b, 0);
            return debit;
          },
          getTransactionString(statement, accountid){
            let transactions = statement.transactions.filter(trans=>trans.accountid==accountid);
            let strings = transactions.map(trans=>trans.transnote).join(' ');
            return strings;
          },
          getBenefitSum(statement){
            let sum=[];
            let transactions = statement.transactions.filter(trans=>trans.transsubtype=='Benefit');
            for(var i in transactions){
              let trans = transactions[i];
              let found_account = sum.find(x=>x.accountid == trans.accountid);
              if(found_account == undefined){
                let sumcredit = this.getCreditAmountByAccount(statement, trans.accountid);
                let sumdebit = this.getDebitAmountByAccount(statement, trans.accountid);
                console.log({
                  accountid: trans.accountid,
                  transcredit: sumcredit,
                  transdebit: sumdebit,
                });
                sum.push({
                  accountid: trans.accountid,
                  transcredit: sumcredit,
                  transdebit: sumdebit,
                  transdesc: trans.transdesc,
                  transnote: trans.transnote,
                  transsubtype: trans.transsubtype,
                });
              }

            }
            this.benefit_sum = sum;
            return sum;
          },
          getSavingSum(statement){
            let transactions = statement.transactions.filter(trans=>trans.transsubtype=='Saving');
            let balance = this.calculateBalanceSaving();
            let opening = {transsubtype: 'Saving', transnote: 'Opening Balance', balance: balance};
            this.saving_sum.push(opening);
            for(var i in transactions){
              let trans = transactions[i];
              balance = balance + trans.transcredit - trans.transdebit;
              trans.balance = balance;
              this.saving_sum.push(trans);
            }
            return this.saving_sum;
          },
        },
        async created () {
          this.initvalue = this.$route.params;
          this.logo = getLogo(this.initvalue.companyid);   
          if(this.initvalue==undefined || this.initvalue._id ==undefined) {this.$router.push({ name: 'PayrollList' })}
          else{
            let result = await this.getPayrollRequest(this.initvalue._id);
            
            let statements = result.paystatements;
            this.data_statements = Object.assign([], statements);
            this.data_statements.sort((a, b) => a.paystatementnum - b.paystatementnum)
            console.log(this.data_statements)
            
            
            for(var i in this.data_statements){
              let statement = this.data_statements[i];
              for(var j in statement.transactions){
                let trans = statement.transactions[j];
                if(statement.balance_all.find(item=>item._id==trans.accountid)==null){
                  statement.balance_all.push({
                    employeeid: trans.employeeid,
                    transdebit: 0,
                    transcredit: 0,
                    transdesc: trans.transdesc,
                    transsubtype: trans.transsubtype,
                    _id: trans.accountid,
                  });
                }
              }          
            }
            if(this.employees.length==0) {this.getEmployeesRequest()}
          }
          this.isDualCurrency = this.data_statements[0].isDualCurrency;
          this.currencyRate = this.data_statements[0].currencyRate;
          this.primaryCurrency = this.data_statements[0].primaryCurrency;
          this.secondaryCurrency = this.data_statements[0].secondaryCurrency;

                 
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
